import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { Header } from '../components/Header';
import { useAuthStore } from '../stores/authStore';

export const AdminLayout = () => {
    const location = useLocation();
    const { user } = useAuthStore();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Convert path to title
    const getPageTitle = () => {
        const path = location.pathname.split('/')[2];
        switch (path) {
            case 'dashboard': return 'Admin Dashboard';
            case 'employees': return 'Manage Employees';
            case 'courses': return 'Course Management';
            case 'certificates': return 'Search & Download Certificates';
            case 'transcripts': return 'Download Transcripts';
            default: return 'Admin Dashboard';
        }
    };

    const handleSidebarToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSidebarClose = () => {
        setIsSidebarOpen(false);
    };

    if (!user) {
        return null; // or a loading state
    }

    return (
        <div className="flex h-screen bg-background">
            <Sidebar 
                userRole="admin"
                isOpen={isSidebarOpen}
                onClose={handleSidebarClose}
            />
            <main className="flex-1 flex flex-col overflow-hidden lg:ml-64">
                <Header
                    title={getPageTitle()}
                    onToggleSidebar={handleSidebarToggle}
                />
                <div className="flex-1 overflow-y-auto p-6 relative">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}; 